import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button } from '@shopify/polaris'

import logoDescImg from 'assets/shopifyAppLogoDesc.png'
import Text from 'components/common/Text'

const Wrapper = styled.div`
  height: 40em;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

const Container = styled.div`
  _height: 20em;
  width: 40em;
  _background-color: #f0f0f0;
  display: flex;
  flex-direction: column;
`
const DescContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1em;

`
const Image = styled.div`
  background-image: url('${logoDescImg}');
  background-repeat: no-repeat;
  background-size: contain;
  height: 8em;
  width: 8em;
  margin-left: 2em;
`
const ButtonsContainer = styled.div`
  margin-top: 1em;
  width: 26em;
  display: flex;
  justify-content: space-between;
`



class CustomizeLogoDesc extends Component {

  onSkipClick = () => {
    const { switchSceneToNext } = this.props
    switchSceneToNext(0, 3)
  }

  render () {
    const { goNext } = this.props
    return (
      <Wrapper>
        <Container>
          <Text size='large'>First, let’s customize your logo</Text>
          <DescContainer>
            <Text containerStyle='width:18em; line-height: 1.5em;'>Let’s start with your logo.  We added the logo from the app store, but if you have a different version (perhaps higher quality) you would like to use, you can upload it on the next step.</Text>
            <Image />
          </DescContainer>
          <ButtonsContainer>
            <Button primary onClick={goNext} size='slim'>Change logo</Button>
            <Button plain onClick={this.onSkipClick}>Looks good, let’s continue</Button>
          </ButtonsContainer>
        </Container>
      </Wrapper>
    )
  }
}


CustomizeLogoDesc.propTypes = {
  goNext: PropTypes.func.isRequired,
  switchSceneToNext: PropTypes.func.isRequired
}

export default CustomizeLogoDesc



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/shopifyUI/CustomizeLogoDesc.js